var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0879 5.32812C16.5754 5.54478 16.9004 6.0052 16.9004 6.51978C16.9004 13.5615 11.7275 16.9198 10.3733 16.9198C9.01914 16.9198 3.90039 13.5073 3.90039 6.51978C3.90039 6.0052 4.19831 5.54478 4.68581 5.32812L9.88581 3.16145C10.0483 3.10728 10.2108 3.0802 10.4004 3.0802C10.5629 3.0802 10.7254 3.10728 10.8879 3.16145L16.0879 5.32812ZM10.4004 15.6198C12.9191 14.5635 15.6004 11.2323 15.6004 6.51978L10.4004 4.35312L5.20039 6.51978C5.20039 11.124 7.74622 14.5365 10.4004 15.6198ZM8.88372 9.7427L9.69622 10.5552L11.8358 8.03645C11.9712 7.87395 12.1608 7.81978 12.3504 7.81978C12.8379 7.81978 13.0004 8.25312 13.0004 8.46978C13.0004 8.6052 12.9462 8.7677 12.8379 8.87603L10.2379 11.9094C10.0483 12.126 9.80456 12.1531 9.75039 12.1531C9.56081 12.1531 9.39831 12.099 9.28997 11.9635L7.98997 10.6635C7.85456 10.5552 7.80039 10.3927 7.80039 10.2031C7.80039 9.85103 8.07122 9.55312 8.45039 9.55312C8.61289 9.55312 8.77539 9.63437 8.88372 9.7427Z",
    fill: "#969AB3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.75d66432.svg";
export { ForwardRef as ReactComponent };